module.exports = __webpack_public_path__ + "assets/img/zpimg4.dffb239d.png";